import Component from "./component";
import * as inkjs from "inkjs";

class Storylet extends Component {
  constructor(asset) {
    super();
    this.script = asset.storyContent;
    this.runner = false;
    this.loopPoint = false;
  }

  startFlow(stage) {
    this.bindStoryRunner(stage);
    document.dispatchEvent(new CustomEvent("ui.transition", {
      detail: {
        command: "ShowStory",
        character: this.owner,
        player: stage.player
      }
    }));
  }

  continueFlow(stage) {
    // this.runner.ChoosePathString(this.loopPoint);
    // this.loopPoint = false;
    document.dispatchEvent(new CustomEvent("ui.transition", {
      detail: {
        command: "ShowStory",
        character: this.owner,
        player: stage.player
      }
    }));
  }

  get currentTags() {
    return this.runner.currentTags;
  }

  saveFlow() {
    this.loopPoint = this.currentKnot;
  }

  get canStart() {
    return this.runner == false;
  }

  canContinue() {
    return this.runner.canContinue;
  }

  continue() {
    const nextLine = this.runner.Continue();

    if (nextLine.match(/^>>[\s]*LEAVE/)) {
      return { leave: true, text: "" }
    } else {
      return { leave: false, text: nextLine }
    }
  }

  get currentKnot() {
    return this.runner.state.currentPathString;
  }

  hasCurrentChoices() {
    return this.runner.currentChoices.length > 0;
  }

  currentChoices() {
    return this.runner.currentChoices;
  }

  ChooseChoiceIndex(index) {
    return this.runner.ChooseChoiceIndex(index);
  }

  bindStoryRunner(stage) {
    this.stage = stage;
    this.runner = new inkjs.Story(this.script);
    this.runner.BindExternalFunction("hasMet", this.hasMet);
    this.runner.BindExternalFunction("hasSeen", this.hasSeen);
    this.runner.BindExternalFunction("hasSeenTile", this.hasSeenTile);
    this.runner.BindExternalFunction("hasRevealed", this.hasRevealed);
    this.runner.BindExternalFunction("revealed", this.revealed);
    this.runner.BindExternalFunction("movePlayer", this.movePlayer);
    this.runner.BindExternalFunction("moveCharacter", this.moveCharacter);
    this.runner.BindExternalFunction("moveEntity", this.moveEntity);
    this.runner.BindExternalFunction("removeEntity", this.removeEntity);
    this.runner.BindExternalFunction("describeItem", this.describeItem);
    this.runner.BindExternalFunction("giveItem", this.giveItem);
    this.runner.BindExternalFunction("hasItem", this.hasItem);
    this.runner.BindExternalFunction("startQuest", this.startQuest);
    this.runner.BindExternalFunction("completeQuest", this.completeQuest);
    this.runner.BindExternalFunction("cancelQuest", this.cancelQuest);
    this.runner.BindExternalFunction("hasQuest", this.hasQuest);
    this.runner.BindExternalFunction("hasStartedQuest", this.hasStartedQuest);
    this.runner.BindExternalFunction("hasCompletedQuest", this.hasCompletedQuest);
    this.runner.BindExternalFunction("flipTile", this.flipTile);
    this.runner.BindExternalFunction("clearTile", this.clearTile);
    this.runner.BindExternalFunction("clearBox", this.clearBox);
    this.runner.BindExternalFunction("clearLocation", this.clearLocation);
    this.runner.BindExternalFunction("clearLocationTiles", this.clearLocationTiles);
  }

  hasMet = (character) => {
    return this.stage.player.social.hasMet(character);
  }

  hasItem = (id) => {
    return this.stage.player.equipment.inventory.some(it => {
      return it.name == id;
    });
  }

  giveItem = (id) => {
    const item = this.stage.player.equipment.removeItem(id);
    this.owner.equipment.addItem(item);
  }

  describeItem = (id) => {
    let item = this.stage.player.equipment.getItem(id);
    if (!item) item = this.owner.equipment.getItem(id);

    return item ? item.quips.examineDescription() : "";
  }

  hasSeen = (x, y) => {
    return this.stage.isSeen(x, y);
  }

  hasSeenTile = (tile) => {
    return this.stage.isSeenTile(tile);
  }

  hasRevealed = (coverage) => {
    return coverage >= this.stage.revealedPercent();
  }

  revealed = () => {
    return this.stage.revealedPercent();
  }

  flipTile = (x, y, tile) => {
    this.stage.flipTile(x, y, tile);
  }

  clearTile = (x, y) => {
    const tile = this.stage.adventure.world.getBackgroundTile(x, y);
    this.stage.flipTile(x, y, tile.name);
    this.stage.refreshVisibility();
  }

  clearBox = (x, y, width, height, tileName=false) => {
    for (let cy=y; cy < (y + height); cy++) {
      for (let cx=x; cx < (x + width); cx++) {
        const currentTile = this.stage.map[cy][cx];
        if (!tileName || tileName == currentTile.name) {
          const backgroundTile = this.stage.adventure.world.getBackgroundTile(cx, cy);
          this.stage.flipTile(cx, cy, backgroundTile.name);
        }
      }
    }
    this.stage.refreshVisibility();
  }

  clearLocation = (id) => {
    const { x, y, width, height } = this.stage.adventure.world.getLocationBounds(id);
    this.clearBox(x, y, width, height);
  }

  clearLocationTiles = (id, tileName) => {
    const { x, y, width, height } = this.stage.adventure.world.getLocationBounds(id);
    this.clearBox(x, y, width, height, tileName);
  }

  movePlayer = (x, y) => {
    this.stage.moveEntityTo(this.stage.player, x, y);
    this.stage.refreshVisibility();
  }

  moveCharacter = (x, y) => {
    this.stage.moveEntityTo(this.owner, x, y);
    this.stage.refreshVisibility();
  }

  moveEntity = (x, y, name) => {
    const entity = this.stage.entities.find(ety => ety.name == name);
    if (entity) {
      this.stage.moveEntityTo(entity, x, y);
    }
  }

  removeEntity = (name) => {
    const entity = this.stage.entities.find(ety => ety.name == name);
    if (entity) {
      this.stage.removeEntity(entity);
    }    
  }

  startQuest = (id) => {
    this.stage.adventure.startQuest(id);
  }

  completeQuest = (id) => {
    this.stage.adventure.completeQuest(id);
  }

  cancelQuest = (id) => {
    this.stage.adventure.cancelQuest(id);
  }

  hasQuest = (id) => {
    return this.stage.adventure.hasQuest(id);
  }

  hasStartedQuest = (id) => {
   return this.stage.adventure.hasStartedQuest(id);
  }

  hasCompletedQuest = (id) => {
    return this.stage.adventure.hasCompletedQuest(id);
  }
}

export default Storylet;